import * as React from "react";
import * as _ from "lodash";
import IStaticDataValue from "../../../common/models/IStaticDataValue";
import {AppPlaceholders} from "../utils/AppConstants";
import {ChangeEvent} from "react";
import TypeAhead, { TypeAheadElement } from "./TypeAhead";
import AppUtils from "../utils/AppUtils";
import IStaticDataTASuggestions from "../models/staticData/IStaticDataTASuggestions";

const mealUnitTypeAheadSuggestions = [
    {displayValue: "katori", internalValue: "katori", suggestByDefault: true},
    {displayValue: "bowl", internalValue: "bowl", suggestByDefault: true},
    {displayValue: "largebowl", internalValue: "large bowl", suggestByDefault: true},
    {displayValue: "teaspoon", internalValue: "teaspoon", suggestByDefault: true},
    {displayValue: "cup", internalValue: "cup", suggestByDefault: true},
    {displayValue: "glass", internalValue: "glass", suggestByDefault: true},
    {displayValue: "piece", internalValue: "piece", suggestByDefault: true},
    {displayValue: "scoop", internalValue: "scoop", suggestByDefault: true},
    /*{displayValue: "tablespoon", internalValue: "tablespoon", suggestByDefault: true},
    {displayValue: "g", internalValue: "g", suggestByDefault: true},
    {displayValue: "ml", internalValue: "ml", suggestByDefault: true}*/
]

export interface MealUnitComponentProps {
    unit: string,
    count: number,
    dropdownItems: IStaticDataValue[] | IStaticDataTASuggestions[],
    rootClass: string,
    onCountChange?: (event: ChangeEvent<HTMLInputElement>) => any,
    onUnitChange?: (value: string) => any,
    onDurationChange?: (elem: TypeAheadElement) => any,
    onDishUnitSelect?: () => void,
    placeholder?: string,
    isFrequency?: boolean
}

export interface MealUnitComponentState {
    unit: number,
    count: string,
    inputText: string,
    autoCompleteText: string
}

class MealUnitComponent extends React.Component<MealUnitComponentProps, MealUnitComponentState> {

    private servingInputDom: any = null;

    constructor(props: MealUnitComponentProps) {
        super(props);
        let inputText = _.isEmpty(props.unit) && (_.isNull(props.count) || props.count === undefined || props.count + "" === "") ?
            null : props.count + " " + props.unit;
        this.state = {
            unit: null,
            count: null,
            inputText,
            autoCompleteText: inputText
        }
    }
    componentDidMount() {
        // this.refs.typeAheadDOM.inputDOM.focus();
        if (this.servingInputDom) {
            this.servingInputDom.focus()
        }
    }

    onDurationInputChange = (input: string) => {
        let frequencySuggestions: TypeAheadElement[] = [];
        this.setState({inputText: input});

        if (/^\d/.test(input)) {
            let withoutNumbers = input.replace(/([0-9]|\.)/g, "").trim();
            let itemsToIterate = !_.isEmpty(this.props.dropdownItems) ? this.props.dropdownItems as any : mealUnitTypeAheadSuggestions;
            if (!_.isEmpty(withoutNumbers)) {
                _.map(itemsToIterate, (frequencyItem) => {
                    if (frequencyItem.displayValue.toLowerCase().indexOf(withoutNumbers.toLowerCase()) !== -1) {
                        let digits = input.match(/([0-9 \.]*)([a-z A-Z]*)/)[1].trim();
                        let typeAheadElement: TypeAheadElement = {
                            value: frequencyItem.internalValue,
                            label: `${digits} ${frequencyItem.displayValue}`,
                            others: {
                                type: "frequency",
                                value: {
                                    count: digits,
                                    unit: frequencyItem.internalValue
                                }
                            }
                        }
                        frequencySuggestions.push(typeAheadElement);
                    }
                })
            } else {
                let filteredSuggestions = itemsToIterate.filter((item: IStaticDataTASuggestions) => item.suggestByDefault === true);
                _.map(filteredSuggestions, (frequencyItem) => {
                    let digits = input.match(/([0-9 \.]*)([a-z A-Z]*)/)[1].trim();
                    let typeAheadElement: TypeAheadElement = {
                        value: frequencyItem.internalValue,
                        label: `${digits} ${frequencyItem.displayValue}`,
                        others: {
                            type: "frequency",
                            value: {
                                count: digits,
                                unit: frequencyItem.internalValue
                            }
                        }
                    }
                    frequencySuggestions.push(typeAheadElement);
                })
            }
        }

        if (frequencySuggestions.length > 0) {
            // this.props.onDurationChange(frequencySuggestions[0]);
            this.setState({
                autoCompleteText: frequencySuggestions[0].additionalInfoLabel
            })
        }
        return Promise.resolve({options: frequencySuggestions, completed: true});
    }

    onCountTypeAheadSelect = (elem: TypeAheadElement) => {
        this.props.onDurationChange(elem);
        this.props.onDishUnitSelect !== undefined ? this.props.onDishUnitSelect() : null;
        let unit = `${elem.others.value.unit}${Number(elem.others.value.count) > 1 ? "s" : ""}`;
        let inputText = elem.others.value.count + " " + unit;
        this.setState({ inputText })
    }

    onDurationInputBlur = () => {
        !_.isEmpty(this.props.onDishUnitSelect) ? this.props.onDishUnitSelect() : null;
        if (!_.isEmpty(this.props.unit) && AppUtils.isDefined(this.props.count) && this.props.count.toString() !== "") {
            let unitToDisplay = this.props.unit;
            let unit = this.props.count > 1 ? unitToDisplay + "s" : unitToDisplay;
            this.setState({
                inputText: `${this.props.count} ${unit}`
            })
        } else {
            this.setState({
                inputText: ""
            })
        }
    }

    componentWillReceiveProps(nextProps: MealUnitComponentProps) {
        if (_.isEmpty(nextProps.unit) && (_.isNull(nextProps.count) || nextProps.count === undefined || nextProps.count.toString() === ""))
            this.setState({
                inputText: null
            })
    }

    getPlaceholderText() {
        if (this.props.isFrequency) return AppPlaceholders.DISH_UNIT;
        else return AppPlaceholders.DISH_UNIT;
    }

    render() {
        let rootClass = this.props.rootClass;
        let placeHolder = this.props.placeholder !== undefined ? this.props.placeholder : this.getPlaceholderText();
        let inputText = this.state.inputText;
        return (
            <div className={"meal-unit-container"}>
                <div className={`${rootClass}-meal-unit`}>
                    <TypeAhead ref={"typeAheadDOM"} name={"frequency-count"} value={inputText || ""}
                               widgetName={"MealUnit"}
                               placeholder={placeHolder}
                               setInputRef={(inputRef: any) => this.servingInputDom = inputRef}
                               onTypeAheadChange={this.onDurationInputChange}
                               onTypeAheadSelect={this.onCountTypeAheadSelect}
                               onTypeAheadBlur={this.onDurationInputBlur} />
                </div>
            </div>
        )
    }
}

export default MealUnitComponent;